<template>
    <span>
        <button
            class="btn"
            data-test-id="add-to-groups-button"
            @click="groupSelected()"
        >
            <span class="icon-add"></span>
            Add to groups
        </button>

        <PrimeDialog
            v-model:visible="isOpen"
            modal
            :closable="true"
            :header="`Add ${ids.length} users to:`"
            :style="{ width: '32rem' }"
            :pt="{ root: { 'data-test-id': 'add-to-groups-dialog' } }"
        >
            <ul class="group-list">
                <li
                    v-for="group in allGroups"
                    :key="group.id"
                >
                    <input
                        :id="`user-group-${group.id}`"
                        v-model="selectedGroupIds"
                        type="checkbox"
                        :value="group.id"
                        :data-test-id="`user-group-checkbox-${group.id}`"
                    />
                    <label :for="`user-group-${group.id}`">{{ group.name }}</label>
                </li>
            </ul>

            <p class="add-new-group">
                <a
                    :href="`/${organizationSlug}/user-groups/create`"
                    target="_blank"
                    data-test-id="add-new-group-link"
                >
                    Add New Group
                </a>
                (This will open the Groups management views in a new tab. You will then be able to add a new group and
                refresh this page to add users to it.)
            </p>

            <template #footer>
                <button
                    class="btn"
                    type="button"
                    data-test-id="add-to-groups-cancel"
                    @click="isOpen = false"
                >
                    Cancel
                </button>
                <button
                    class="btn btn-primary"
                    type="button"
                    :disabled="submitting"
                    data-test-id="add-to-groups-confirm"
                    @click="addToGroups()"
                >
                    OK
                </button>
            </template>
        </PrimeDialog>
    </span>
</template>

<script>
import PrimeDialog from 'primevue/dialog'
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    name: 'UserGroupsActionButton',

    components: {
        PrimeDialog,
    },

    mixins: [canToast, needsOrganizationSlug],

    props: ['ids'],

    data() {
        return {
            allGroups: [],
            // The checkboxes bind straight to this, so the selection no
            // longer has to be read back out of the DOM on confirm.
            selectedGroupIds: [],
            isOpen: false,
            submitting: false,
        }
    },

    mounted() {
        this.$http.get(`/${this.organizationSlug}/user-groups/all`).then(({ data }) => {
            this.allGroups = data
        })
    },

    methods: {
        groupSelected() {
            this.selectedGroupIds = []
            this.isOpen = true
        },

        addToGroups() {
            if (this.submitting) {
                return
            }

            this.submitting = true

            this.$http
                .post(`/${this.organizationSlug}/users/add-many-to-groups`, {
                    users: this.ids,
                    groups: this.selectedGroupIds,
                })
                .then(() => {
                    this.isOpen = false
                    this.$emit('reload')
                    this.toast('Users successfully added to groups')
                })
                .catch((error) => {
                    const { errors } = error.response.data

                    this.toast([].concat(...Object.values(errors)).join(' '), 'error')
                })
                .finally(() => {
                    this.submitting = false
                })
        },
    },
}
</script>

<style scoped lang="scss">
.group-list {
    max-height: 40vh;
    overflow-y: auto;

    li {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 6px;
    }
}

.add-new-group {
    margin-top: 12px;
    font-size: 0.875rem;
}
</style>
